// @flow

import React, { Component } from 'react';
import glamorous from 'glamorous';
import { margin } from 'polished';
import Tappable from 'app/components/commons/Tappable';

type Props = {
  className?: string,
  children: React.Node,
  icon?: any,
  id?: number | string,
  onClick: (id: number | string) => void,
  selected: boolean,
  scheme?: 'light' | 'dark',
  style?: Object,
};

const StyledDiv = glamorous.div(
  {
    border: '1px solid',
    textTransform: 'uppercase',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 3,
  },
  ({ theme }) => ({
    fontSize: theme.fontSize.tiny,
    borderColor: 'currentColor',
    padding: theme.spacing.tiny,
    ...margin(theme.spacing.tiny, 0),
    fontWeight: theme.fontWeight.demiBold,
  }),
  ({ selected, theme, scheme }) =>
    (selected
      ? {
        backgroundColor: scheme === 'light' ? theme.color.basis1 : theme.color.white,
        color: scheme === 'light' ? theme.color.white : theme.color.basis1,
        borderColor: scheme === 'light' ? theme.color.basis6 : theme.color.basis1,
      }
      : {}),
);

const Text = glamorous.span({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

class FilterButton extends Component<Props> {
  props: Props;
  static defaultProps = {
    className: undefined,
    icon: undefined,
    id: undefined,
    scheme: 'light',
    style: undefined,
  };

  handleClick = () => {
    const { id, onClick } = this.props;
    onClick(id);
  };

  render() {
    const { children, className, icon, selected, scheme, style } = this.props;

    return (
      <Tappable
        className={className}
        component={StyledDiv}
        onTap={this.handleClick}
        selected={selected}
        scheme={scheme}
        style={style}
      >
        {icon}
        <Text>{children}</Text>
      </Tappable>
    );
  }
}

export default FilterButton;
